var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 82,
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5 16A38.825 38.825 0 0 0 70 39c0 21.54 17.46 39 39 39s39-17.46 39-39-17.46-39-39-39C96.196 0 84.834 6.17 77.723 15.699c-3.8-.95-6.585-4.037-6.585-7.699 0-4.418 4.053-8 9.054-8h126.754c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 64 0 60.418 0 56s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h49.046Zm129.446 32c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 35.582 216 40s-4.054 8-9.054 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(71 1)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 49 14-6m4-4.136 8.24-18.542M102 20l14.52 20",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78 60.5 9.857-6.885c1.78-2.587 5.887-3.81 12.322-3.672 9.651.207 12.956 6.111 19.221 5.508 6.265-.604 7.584-1.043 13.84-7.086 4.171-4.028 8.758-9.316 13.76-15.865",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    x: 98.5,
    y: 15.5,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    x: 116.5,
    y: 40.5,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    x: 87.5,
    y: 39.5,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    x: 130.5,
    y: 24.5,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.5 40.5 10-12M134 24l7-7",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphData);
export default __webpack_public_path__ + "static/media/graph-data.fb960d2c1e6abc9bb158f23af771d4f8.svg";
export { ForwardRef as ReactComponent };